module.exports = __webpack_public_path__ + "static/texture-f8ca64df22c32d772792086b2319e41a.png";